import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const deleteGroup = groupId => {
  return Helpers.delete(`${Constants.GROUPS_URL}/${groupId}`, {});
};

export const saveGroup = group => {
  return Helpers.post(`${Constants.GROUPS_URL}`, {}, group);
};
